module.exports = __webpack_public_path__ + "static/media/DesignSmartSlide03.3ed2d8b7.jpg";